<template>
  <button v-if="value" @click.stop="handleClick">
    {{ value.displayName !== null ? value.displayName : 'Invoice' }}
  </button>
</template>

<script setup lang="ts">
import { ExternalInvoice } from '@/models/batch'

const props = defineProps<{
  value?: ExternalInvoice | null
}>()

function handleClick() {
  if (props.value) {
    window.open(props.value.link, '_blank')
  }
}
</script>

<style scoped>
button {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  color: #0000ee;
  text-decoration: underline; /* Underline text to resemble a link */
  display: inline; /* Ensure the button takes only as much width as its content */
}

/* Remove default button styles */
button:focus {
  outline: none;
}
</style>
